import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Linkedin, Facebook, Instagram } from "lucide-react";
import Logo from "../Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="nx-container pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <Logo variant="full" height={56} />
            <p className="mt-6 text-mist text-[16px] leading-relaxed max-w-xs">
              Facility Management global pour entreprises, collectivités et sites tertiaires.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-[10px] border border-white/20 flex items-center justify-center hover:bg-cyan hover:border-cyan hover:text-navy transition-all"
                data-testid="social-linkedin"
              >
                <Linkedin size={18} strokeWidth={1.75} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-[10px] border border-white/20 flex items-center justify-center hover:bg-cyan hover:border-cyan hover:text-navy transition-all"
                data-testid="social-facebook"
              >
                <Facebook size={18} strokeWidth={1.75} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-[10px] border border-white/20 flex items-center justify-center hover:bg-cyan hover:border-cyan hover:text-navy transition-all"
                data-testid="social-instagram"
              >
                <Instagram size={18} strokeWidth={1.75} />
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="text-white text-[16px] font-semibold mb-6 uppercase tracking-[0.14em]" style={{ fontSize: 16 }}>
              Navigation
            </h4>
            <ul className="space-y-3">
              <li><Link to="/" className="nx-footer-link" data-testid="footer-nav-accueil">Accueil</Link></li>
              <li><Link to="/services" className="nx-footer-link" data-testid="footer-nav-services">Services</Link></li>
              <li><Link to="/pourquoi-nous" className="nx-footer-link" data-testid="footer-nav-pourquoi">Pourquoi nous ?</Link></li>
              <li><Link to="/a-propos" className="nx-footer-link" data-testid="footer-nav-apropos">À propos</Link></li>
              <li><Link to="/contact" className="nx-footer-link" data-testid="footer-nav-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white text-[16px] font-semibold mb-6 uppercase tracking-[0.14em]" style={{ fontSize: 16 }}>
              Informations
            </h4>
            <ul className="space-y-3">
              <li><Link to="/faq" className="nx-footer-link" data-testid="footer-faq">Questions fréquentes</Link></li>
              <li><Link to="/mentions-legales" className="nx-footer-link" data-testid="footer-legal">Mentions légales</Link></li>
              <li><Link to="/confidentialite" className="nx-footer-link" data-testid="footer-privacy">Politique de confidentialité</Link></li>
              <li><Link to="/plan-du-site" className="nx-footer-link" data-testid="footer-sitemap">Plan du site</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-[16px] font-semibold mb-6 uppercase tracking-[0.14em]" style={{ fontSize: 16 }}>
              Contact
            </h4>
            <ul className="space-y-4 text-mist text-[16px]">
              <li className="flex items-start gap-3">
                <MapPin size={18} strokeWidth={1.75} className="text-cyan mt-1 shrink-0" />
                <span className="whitespace-nowrap">56 avenue Aristide Briand<br/>93240 Stains, France</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} strokeWidth={1.75} className="text-cyan shrink-0" />
                <a href="tel:+33189628787" className="nx-footer-link whitespace-nowrap" data-testid="footer-phone">01 89 62 87 87</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} strokeWidth={1.75} className="text-cyan shrink-0" />
                <a href="mailto:contact@novanextfacility.fr" className="nx-footer-link whitespace-nowrap" style={{ fontSize: 15 }} data-testid="footer-email">contact@novanextfacility.fr</a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="nx-divider-dark my-12" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-mist text-[14px] leading-relaxed">
            <p><span className="text-white font-medium">NOVANEXT SERVICES GENERAUX</span> — Facility Management · Multi-expertises</p>
            <p>SIREN 985 261 973 · RCS Bobigny</p>
          </div>
          <p className="text-mist text-[14px]">
            © {year} NOVANEXT Services Généraux. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
